import { AnalyticsRequest, Metric, GroupBy, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { DefaultWidgetPosition } from './PanelTemplatesTheme/constants';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { WIDGET_LABEL_SIZE } from 'components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { TEXT_SHADOW_DEFAULT } from 'models/Widget/Widget';

export var WidgetSunburst: Widget = {
    type: 'sunburst',
    id: 'sunburst',
    name: 'Sunburst',
    useGlobalTimePeriod: true,
    useGlobalTranslate: true,
    translationLanguage: null,
    analyticsRequests: [
        // Note: All global variables like reportingEngine, report, filters, and projections
        // are injected via AnalyticsRequest.getRequests()
        new AnalyticsRequest({
            limit: 100,
            projections: [
                new Metric({
                    ADVOCACY: { dimensionName: 'POINTS' },
                }),
            ],
            groupBys: [
                new GroupBy({
                    LISTENING: { source: ListeningDimensions.topicCluster },
                    INBOUND_MESSAGE: { dimensionName: 'ACCOUNT_ID' },
                    PLATFORM: { dimensionName: 'ACCOUNT_ID' },
                    BENCHMARKING: { dimensionName: 'BENCHMARKING_ACCOUNT_ID' },
                    PAID: { dimensionName: 'accountIds' },
                    ADVOCACY: { dimensionName: 'COMMUNITY_USER_ID' },
                    RDB_FIREHOSE: { dimensionName: 'RDB_QUERY_IDS' },
                    STORY_MESSAGE: { dimensionName: 'STORY_CATEGORY' },
                }),
            ],
            sorts: [
                new Sort({ order: 'DESC', projections: 0 }),
                new Sort({ order: 'ASC', groupBys: 0 }),
            ],
            timePeriods: [{ key: 'last_7_days' }, { previousPeriod: true }],
        }) as any,
    ],
    position: DefaultWidgetPosition,
    label: {
        titleText: 'Sunburst',
        enabled: false,
        size: WIDGET_LABEL_SIZE.primary,
        textShadow: TEXT_SHADOW_DEFAULT,
    },
    options: {
        player: {
            playing: true,
            duration: 15,
        },
        smartSize: {
            enabled: true,
            mode: 'responsive',
            size: 'm',
        },
        portrait: {
            widgetOrientation: 'portrait',
        },
    },
};
